module.exports = __webpack_public_path__ + "img/textImgs.66fd145e.png";